<template>
  <div id="modemView">
    <div class="modem_view_tit" :class="selectedModem.currentState">
      모뎀정보 상세 ({{selectedModem.mobileNum}} |
      <template v-if="selectedModem.currentState != null">
        <template v-for="crs in crsList" v-if="crs.codeValue === selectedModem.currentState">{{crs.codeName}})</template>
      </template>
      <template v-else>-)</template>
    </div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            <template v-if="selectedModem.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === selectedModem.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="selectedModem.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (selectedModem.officeCode.length === 5 ? selectedModem.officeCode : selectedModem.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              <template v-if="selectedModem.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === selectedModem.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="selectedModem.affiliateCode == null && selectedModem.officeCode == null">-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>사업구분</div>
          <div>
            <template v-if="selectedModem.projectType != null">
              <template v-for="prt in prtList" v-if="prt.codeValue === selectedModem.projectType">{{prt.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>구축구분</div>
          <div>
            <template v-if="selectedModem.structType != null">
              <template v-for="stt in sttList" v-if="stt.codeValue === selectedModem.structType">{{stt.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모델명</div>
          <div>
            <template v-if="selectedModem.modelName != null">{{selectedModem.modelName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>
            <template v-if="selectedModem.mobileNum != null">{{selectedModem.mobileNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>USIM</div>
          <div>
            <template v-if="selectedModem.usim != null">{{selectedModem.usim}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>SN</div>
          <div>
            <template v-if="selectedModem.serialNum != null">{{selectedModem.serialNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
<!--      <div class="common_view_item">-->
<!--        <div>-->
<!--          <div>IMEI</div>-->
<!--          <div>-->
<!--            <template v-if="selectedModem.imei != null">{{selectedModem.imei}}</template>-->
<!--            <template v-else>-</template>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="common_view_item">
        <div>
          <div>납품일</div>
          <div>
            <template v-if="selectedModem.supplyDate != null">{{selectedModem.supplyDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>개통일</div>
          <div>
            <template v-if="selectedModem.connectedDate != null">{{selectedModem.connectedDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>등록일</div>
          <div>
            <template v-if="selectedModem.registerDate != null">{{selectedModem.registerDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>진행현황</div>
          <div>
            <template v-if="selectedModem.progressType != null">
              <template v-for="prg in prgList" v-if="prg.codeValue === selectedModem.progressType">{{prg.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현재상태</div>
          <div>
            <template v-if="selectedModem.currentState != null">
              <template v-for="crs in crsList" v-if="crs.codeValue === selectedModem.currentState">{{crs.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>비고</div>
          <div>
            <template v-if="selectedModem.note != null">{{selectedModem.note}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
    <div class="modem_view_button" v-if="selectedModem.currentState === 'CRS03'" @click="addModem">회선관리: 정지해제 요청</div>
  </div>
</template>

<script>
import common from '../../script/common'
import modemStop from '../../script/modemStop'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      // Modem
      selectedModem: {}
    }
  },
  mounted () {
    this.selectedModem = this.$route.params.data
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.ofc2List = this.getOfc2List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      return this.ofcList.filter(item => { return item.codeLevel === 1 })
    },
    addModem () {
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      modemStop.modemStop('put', {
        isStop: false,
        numList: [this.selectedModem.mobileNum]
      }, response => {
        console.log('[회선관리: 정지해제] 요청 등록', response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '정지 해제 요청을 등록했습니다.')
          this.$router.push('/ModemSearch')
        } else {
          common.amsAlert('retry', '정지 해제 요청을 등록하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#modemView .modem_view_tit {
  padding: 14px 26px;
  background: #F14950;
  box-sizing: border-box;
  color: #FFF;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
}

#modemView .modem_view_tit.CRS01 {
  background: #4BA06C;
}

#modemView .common_view_list > .common_view_item > div > div {
  padding: 14px 26px;
  color: #36414F;
  font-size: 12px;
  line-height: 22px;
}

#modemView .common_view_list > .common_view_item > div > div:nth-child(1) {
  width: 150px;
  font-weight: 700;
}

#modemView .common_view_list > .common_view_item > div > div:nth-child(2) {
  padding-left: 0;
  font-weight: 400;
}

#modemView .modem_view_button {
  height: 57px;
  border-radius: 4px;
  margin-top: 56px;
  background: #4BA06C;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 57px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/ModemView.vue